import React from "react";
import ReactDOM from "react-dom/client";
import App from "@/App";
import "@/index.css";

// Patch for Google Maps + React DOM conflict
// Google Maps manipulates DOM directly, causing React's removeChild to fail
const originalRemoveChild = Node.prototype.removeChild;
Node.prototype.removeChild = function(child) {
  if (child.parentNode !== this) {
    return child;
  }
  return originalRemoveChild.call(this, child);
};

// Suppress cross-origin "Script error" overlay from third-party scripts (Google Maps etc.)
window.addEventListener('error', (e) => {
  if (e.message === 'Script error.' || e.message === 'Script error') {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Service worker DISABLED during development to prevent cache issues
// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker.register('/sw.js')
//       .then((registration) => {
//         console.log('✅ SW registered: ', registration);
//       })
//       .catch((registrationError) => {
//         console.log('❌ SW registration failed: ', registrationError);
//       });
//   });
// }
